import { CFBaseSearchbarUtils } from '..';
import { CFMixins } from '../../../../mixins';
export const fontSize = ({ fieldSize }) => CFBaseSearchbarUtils.getTypeSpec(fieldSize).fontSize;
export const typeSpec = ({ fieldSize }) => {
    return CFMixins.typeSpec(CFBaseSearchbarUtils.getTypeSpec(fieldSize));
};
